//@flow
import * as React from 'react'
import type { ContainerRowError$Props } from './flowTypes'

const ContainerRowError=(props:ContainerRowError$Props)=>{
    if (props.errorMsg){
        return (
            <div className='row'>
                <div className="col-sm">
                    <div className="alert alert-danger">
                        <strong>ERROR!</strong> {props.errorMsg}
                    </div>   
                </div>
            </div>
        )
    }
    return null
}

export default ContainerRowError


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowError.js